import styled from '@emotion/styled';

export const LoaderWrapper = styled.div({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '1em',
});
